import NidraMark from "@/components/NidraMark";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-6 text-center"
    >
      <NidraMark className="bottom-[-12%] right-[-8%]" />
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#171512]/45">404</p>
      <h1 className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-[#171512] sm:text-5xl">
        this page drifted <span className="font-serif italic">off the map.</span>
      </h1>
      <p className="mt-6 max-w-sm text-sm leading-[1.8] text-[#171512]/60">
        Whatever you were looking for is not here. The waitlist, however, still is.
      </p>
      <div className="mt-10 flex items-center gap-4">
        <a
          data-testid="not-found-join-button"
          href="/#waitlist"
          className="rounded-full bg-[#171512] px-6 py-3.5 font-mono text-[11px] font-medium uppercase tracking-[0.2em] text-[#F8F4ED] transition-colors duration-200 hover:bg-[#F5C7D4] hover:text-[#171512]"
        >
          join now
        </a>
        <a
          data-testid="not-found-home-link"
          href="/"
          className="rounded-full border border-[#171512]/25 px-6 py-3.5 font-mono text-[11px] uppercase tracking-[0.22em] text-[#171512] transition-colors duration-200 hover:border-[#171512]"
        >
          back home
        </a>
      </div>
    </div>
  );
}
